import Model from 'vuex-model-store-generator'
import axios from '@/js/plugins/client'

import enlace_externo from './enlace_externo'
import enlace_externo_documento from './enlace_externo_documento'
import persona from './persona'

import configDocGenerado from './docGenerado'
import configPlantilla from './plantilla'
import configDocumento from './documento_n'
import configOperacion from './operacion'
import configTipoDocumento from './tipo_documento'
import configTipoTramite from './tipo_tramite'
import configDependencia from './dependencia'
import configFirmaToken from './firma_token'

export const Documento = new Model(configDocumento, axios)
export const Operacion = new Model(configOperacion, axios)
export const DocGenerado = new Model(configDocGenerado, axios)
export const Plantilla = new Model(configPlantilla, axios)
export const TipoDocumento = new Model(configTipoDocumento, axios)
export const TipoTramite = new Model(configTipoTramite, axios)
export const Dependencia = new Model(configDependencia, axios)
export const FirmaToken = new Model(configFirmaToken, axios)

export const EnlaceExterno = new Model(enlace_externo, axios)
export const EnlaceExternoDocumento = new Model(enlace_externo_documento, axios)
export const Persona = new Model(persona, axios)